import { render, staticRenderFns } from "./customPlayer.vue?vue&type=template&id=4dc0fa66&scoped=true"
import script from "./customPlayer.vue?vue&type=script&lang=js"
export * from "./customPlayer.vue?vue&type=script&lang=js"
import style0 from "./customPlayer.vue?vue&type=style&index=0&id=4dc0fa66&prod&lang=scss&scoped=true"
import style1 from "./customPlayer.vue?vue&type=style&index=1&id=4dc0fa66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc0fa66",
  null
  
)

export default component.exports